import { GoodgamePartners } from "./../constants/GoodgamePartners";
import { CampaignVarsVO } from "./../marketing/google/CampaignVarsVO";
import { DictionaryUtil } from "./../utils/DictionaryUtil";
import { AccountCookie } from "./../cookie/AccountCookie";
import { IEnvironmentGlobals } from "./IEnvironmentGlobals";
import { CachebreakerInfoObject } from "./CachebreakerInfoObject";
import { CampaignVars } from "../marketing/google/CampaignVars";
import { BasicURLVariables, paramToString, paramToBool, paramToNum } from "./startup/BasicURLVariables";
import { BasicJSVariables } from "./startup/BasicJSVariables";
import { IVersionInformation } from "./IVersionInformation";
import { VersionInformation } from "./VersionInformation";
import { IdentitiyManagementLicenseTableRegistrationVO } from "./vo/IdentitiyManagementLicenseTableRegistrationVO";
import { CDN } from "@goodgamestudios/world-assignment";
import { BasicConstants } from "./constants/BasicConstants";
import { EnvGlobalsHandler } from "./EnvGlobalsHandler";
import { getLogger } from "@goodgamestudios/logger";
export { AccountCookie } from "../cookie/AccountCookie";
export { DictionaryUtil } from "../utils/DictionaryUtil";
export { CampaignVarsVO } from "../marketing/google/CampaignVarsVO";
export { GoodgamePartners } from "../constants/GoodgamePartners";

const logger = getLogger("BasicEnvironmentGlobals");

export class BasicEnvironmentGlobals implements IEnvironmentGlobals {
    private _forceInstanceConnect: boolean = false;
    private _defaultInstance: number = 0;
    private _invitedBy: string;
    private _isTest: boolean = false;
    private _isLiveTest: boolean = false;
    private _isDevTest: boolean = false;
    private _isUsabilityTest: boolean = false;
    private _isPreClient: boolean = false;
    private _isLocaTest: boolean = false;
    private _isLocal: boolean = false;
    private _isLocalHost: boolean = false;
    private _isLiveBranchingEnvironment: boolean = false;
    private _isFeatureBranchEnvironment: boolean = false;
    private _branchId: string;
    private _branchVersion: string;
    private _featureBranchId: string;
    private _featureBranchEnvironment: string;


    private _campainVars: CampaignVars;
    private _urlVariables: BasicURLVariables;
    /** Stores variables from javascript **/
    private _jsVariables: BasicJSVariables;
    private _langVersionDict: Map<any, any>;
    private _hasNetworkBuddies: boolean = false;
    private _networknameString: string;
    private _enableFeedMessages: boolean = false;
    private _enablelonelyCow: boolean = false;
    private _requestPayByJS: boolean = false;
    private _networkNewsByJS: boolean = false;
    private _earnCredits: number = 0;
    private _allowedfullscreen: boolean = false;
    private _loginIsKeyBased: boolean = false;
    private _useexternallinks: boolean = false;
    private _invitefriends: boolean = false;
    private _minUsernameLength: number = 0;
    private _maxUsernameLength: number = 0;
    private _usePayment: boolean = false;
    private _isFirstVisitOfGGS: boolean = false;
    private _isFirstVisit: boolean = false;
    private _showVersion: boolean = false;
    /** flag if logging for GoodgameLogger is active. */
    private _isLoggingActive: boolean = true;
    /** flag if loading texts should be shown. */
    private _showLoadingText: boolean = false;
    /** flaf if ggs-Zip can be use, default true */
    private _useZipXMLs: boolean = true;
    /** flag if ab testing is active */
    private _useABTest: boolean = false;
    /** url of used cdn */
    private _cdnSubDomain: string = "content";
    /** filsize of MainSwf*/
    private _gameFileSize: string = "content";
    /** filsize of FrameOneSwf in Kilobytes*/
    private _frameOneSizeInKB: number = 0;
    /** flag is client is on private test server */
    private _isPrivateTestServer: boolean = false;
    /** value of the last tracked gamestate for non-linear tracking*/
    private _previousFirstInstanceGamestate: string;
    private _registered: boolean = false;
    private _sessionStartTime: number = NaN;
    private _maintenanceMode: boolean = false;
    protected _currentCountryLanguageCode: string = "";
    protected _currentCountryLanguageVersion: number = 0;


    private _displayName: string;
    private _baseURL: string;
    private _gender: string;
    private _accessKey: string;
    private _distributorId: string;
    private _useVersionedFontSWF: boolean = true;
    private _accountCookie: AccountCookie;

    private _cacheBreakerInfo: CachebreakerInfoObject;
    private _gameSwfLoadingTime: number = 0;
    private _defaultCDN: CDN = CDN.Akamai;
    private _customCDN: CDN = CDN.None;
    private _useFallbackCDN: boolean = false;
    private _isIdentityManagementActive: boolean = false;
    private _underAgeConnectionLost: boolean = false;
    private _isLandingPageClient: boolean;
    private _sig: string;
    private _suk: string;
    private _pln: string;
    private _baseAssetsURL: string;
    private _networkId: number;
    private _isCooleSpiele: boolean;
    private _href: string;
    private _referrer: string;
    private _sessionId: string;
    // siren24 id
    private _identiyManagementID: string = "";

    private static URL_PROTOCOL: string = BasicConstants.DOMAIN_PROTOCOL + "://";
    private static REF_COOLE_SPIELE: string = "coolespiele.com";


    /**
     * Networkd Id is passed as Get Param when game is loaded  by SocialNetworks - otherwise Defaults to our internal GGS 1
     * @returns {number}
     */
    public get networkId(): number {
        if (!this._networkId) {
            this._networkId = paramToNum(this.urlVariables.urlParams.get("network"), GoodgamePartners.NETWORK_GENERAL);
        }
        return this._networkId;
    }

    public get isLandingPageClient(): boolean {
        if (!this._isLandingPageClient) {
            this._isLandingPageClient = paramToBool(this.urlVariables.urlParams.get("clp"));
        }
        return this._isLandingPageClient;
    }

    /**
     * Portal Login (credential of the SSO / networkportal   OR  in case of SupportLogin / Hydra the email of the user
     * @returns {string}
     */
    public get pln(): string {
        if (!this._pln) {
            this._pln = paramToString(this.urlVariables.urlParams.get(BasicConstants.PLN_PARAMETER));
        }
        return this._pln;
    }

    /**
     Signature (Hash generated by Integration page )
     */

    public get sig(): string {
        if (!this._sig) {
            this._sig = paramToString(this.urlVariables.urlParams.get(BasicConstants.SIG_PARAMETER));
        }
        return this._sig;
    }

    /**
     * Support Login Hash ( generated by Integration page )
     */
    public get suk(): string {
        if (!this._suk) {
            this._suk = paramToString(this.urlVariables.urlParams.get(BasicConstants.SUK_PARAMETER));
        }
        return this._suk;
    }


    public set branchId(value: string) {
        this._branchId = value;
    }

    public get branchId(): string {
        return this._branchId;
    }

    public set branchVersion(value: string) {
        this._branchVersion = value;
    }

    public get branchVersion(): string {
        return this._branchVersion;
    }

    public set featureBranchId(value: string) {
        this._featureBranchId = value;
    }

    public get featureBranchId(): string {
        return this._featureBranchId;
    }

    public set featureBranchEnvironment(value: string) {
        this._featureBranchEnvironment = value;
    }

    public get featureBranchEnvironment(): string {
        return this._featureBranchEnvironment;
    }

    public get urlAGB(): string {
        return BasicConstants.uniqueAgbLink(this._currentCountryLanguageCode);
    }

    public get urlPolicy(): string {
        return BasicConstants.uniquePolicyLink(this._currentCountryLanguageCode);
    }

    public get gameId(): number {
        return -1;
    }

    public get gameTitle(): string {
        return "Basic";
    }

    public get currentGameTitle(): string {
        return "Current Title";
    }

    public get gameDir(): string {
        return this.gameTitle.toLowerCase();
    }

    public get availableLanguages(): any[] {
        let availableLanguagesArray: any[] = [];
        if (typeof this.langVersionDict === "undefined" || this.langVersionDict === null) {
            return [];
        }
        for (let lang of DictionaryUtil.getKeys(this.langVersionDict)) {
            availableLanguagesArray.push(lang);
        }
        return availableLanguagesArray;
    }

    public get domain(): string {
        return "goodgamestudios.com";
    }

    public get itemLibName(): string {
        return this.gameTitle + "ItemLib";
    }

    public get buildNumberGame(): string {
        return this.versionInformation.buildNumberGame;
    }

    public get gamePackageVersion(): string {
        return this.versionInformation.versionNumberGame;
    }

    public get versionText(): string {
        return this.versionInformation.versionText;
    }

    public get itemXmlVersion(): string {
        return this.versionInformation.itemXmlVersion;
    }

    public get versionNumberItemsXML(): string {
        return this.versionInformation.basicVersionNumberItemsXML;
    }

    public get versionNumberAchievementXML(): string {
        return null;
    }

    public get versionNumberLevelXpXML(): string {
        return null;
    }

    public get versionDateGame(): string {
        return null;
    }

    public get numOfItemLibs(): number {
        return 1;
    }


    public get cookieName(): string {
        return "Goodgame" + this.gameTitle + "_" + this.networkId /*+ (isTest ? "_test" : "")*/;
    }

    public get analyticsTrackingPath(): string {
        return "/goodgameBasic";
    }

    public get zipSuffix(): string {
        if (this._useZipXMLs) {
            return "ggs";
        }
        else {
            return "xml";
        }
    }

    public get blueboxPort(): number {
        return 80;
    }

    public get blueboxPollSpeed(): number {
        return 500;
    }

    public get useAutoLogin(): boolean {
        return !this._urlVariables.forceManualLogin;
    }

    public get useZipXMLs(): boolean {
        return this._useZipXMLs;
    }

    public set useZipXMLs(value: boolean) {
        this._useZipXMLs = value;
    }

    public get showVersion(): boolean {
        return this._showVersion;
    }

    public set showVersion(value: boolean) {
        this._showVersion = value;
    }

    public get buildNumberServer(): string {
        return this.versionInformation.buildNumberServer;
    }

    public set buildNumberServer(value: string) {
        this.versionInformation.buildNumberServer = value;
    }

    public get minUsernameLength(): number {
        return this._minUsernameLength;
    }

    public set minUsernameLength(value: number) {
        this._minUsernameLength = value;
    }

    public get maxUsernameLength(): number {
        return this._maxUsernameLength;
    }

    public set maxUsernameLength(value: number) {
        this._maxUsernameLength = value;
    }

    public get useexternallinks(): boolean {
        return this._useexternallinks;
    }

    public set useexternallinks(value: boolean) {
        this._useexternallinks = value;
    }

    public get invitefriends(): boolean {
        return this._invitefriends;
    }

    public set invitefriends(value: boolean) {
        this._invitefriends = value;
    }

    public get loginIsKeyBased(): boolean {
        return this._loginIsKeyBased;
    }

    public set loginIsKeyBased(value: boolean) {
        this._loginIsKeyBased = value;
    }

    /** flag if player visits first time ggs games */
    public get isFirstVisitOfGGS(): boolean {
        return this._isFirstVisitOfGGS;
    }

    public set isFirstVisitOfGGS(value: boolean) {
        this._isFirstVisitOfGGS = value;
    }

    public get isFirstVisit(): boolean {
        return this._isFirstVisit;
    }

    public set isFirstVisit(value: boolean) {
        this._isFirstVisit = value;
    }

    public get enableFeedMessages(): boolean {
        return this._enableFeedMessages;
    }

    public set enableFeedMessages(value: boolean) {
        this._enableFeedMessages = value;
    }

    public get enableLonelyCow(): boolean {
        return this._enablelonelyCow;
    }

    public set enableLonelyCow(value: boolean) {
        this._enablelonelyCow = value;
    }

    public get requestPayByJS(): boolean {
        return this._requestPayByJS;
    }

    public set requestPayByJS(value: boolean) {
        this._requestPayByJS = value;
    }

    public get networkNewsByJS(): boolean {
        return this._networkNewsByJS;
    }

    public set networkNewsByJS(value: boolean) {
        this._networkNewsByJS = value;
    }

    public get earnCredits(): number {
        return this._earnCredits;
    }

    public set earnCredits(value: number) {
        this._earnCredits = value;
    }

    public get forceInstanceConnect(): boolean {
        return this._forceInstanceConnect;
    }

    public set forceInstanceConnect(value: boolean) {
        this._forceInstanceConnect = value;
    }

    public get defaultInstanceId(): number {
        return this._defaultInstance;
    }

    public set defaultInstanceId(value: number) {
        this._defaultInstance = value;
    }


    public get networknameString(): string {
        return this._networknameString;
    }

    public set networknameString(value: string) {
        this._networknameString = value;
    }

    public get hasNetworkBuddies(): boolean {
        return this._hasNetworkBuddies;
    }

    public set hasNetworkBuddies(value: boolean) {
        this._hasNetworkBuddies = value;
    }

    public get allowedfullscreen(): boolean {
        return this._allowedfullscreen;
    }

    public set allowedfullscreen(value: boolean) {
        this._allowedfullscreen = value;
    }

    public set href(value: string) {
        this._href = value;
    }

    public get href(): string {
        return this._href || window.document.location.href || document.location.href;
    }

    public set referrer(value: string) {
        this._referrer = value;
    }

    public get referrer(): string {
        return this._referrer || window.document.referrer || document.location.href;
    }

    public get cleanReferrer(): string {
        let cleanRef: string = this.referrer || "";

        if (cleanRef.includes("?")) {
            cleanRef = cleanRef.split("?")[0];
        }

        if (cleanRef.charAt(cleanRef.length - 1) === "/") {
            cleanRef = cleanRef.substring(0, cleanRef.length - 1);
        }

        return cleanRef;
    }

    public get localizeReplacements(): boolean {
        return false;
    }

    public get neverUseAbbreviations(): boolean {
        return false;
    }

    public get abbreviationThreshold(): number {
        return 100000;
    }

    public get fractionalDigits(): number {
        return -1;
    }

    public get leadingZero(): boolean {
        return true;
    }

    public get trailingZeros(): boolean {
        return true;
    }

    public get invitedBy(): string {
        return this._invitedBy;
    }

    public set invitedBy(value: string) {
        this._invitedBy = value;
    }

    public get accountId(): string {
        return (this._accountCookie && this._accountCookie.accountId) ? this.accountCookie.accountId : "-1";
    }


    public get campainVars(): CampaignVars {
        return this._campainVars;
    }

    /**
     * Initialize campaign vars only once. Will be called first in BasicCacheBreakerSwf
     * @param data
     */
    public initCampaignVars(campaignVarsVO: CampaignVarsVO): void {
        if (!this._campainVars) {
            this._campainVars = new CampaignVars();
        }
        this._campainVars.initialize(campaignVarsVO);
    }

    public get urlVariables(): BasicURLVariables {
        if (!this._urlVariables) {
            this._urlVariables = new BasicURLVariables();
        }
        return this._urlVariables;
    }

    public get jsVariables(): BasicJSVariables {
        if (!this._jsVariables) {
            this._jsVariables = new BasicJSVariables();
        }
        return this._jsVariables;
    }

    public get isTest(): boolean {
        return this._isTest;
    }

    public set isTest(value: boolean) {
        this._isTest = value;
    }

    public get isDevTest(): boolean {
        return this._isDevTest;
    }

    public set isDevTest(value: boolean) {
        this._isDevTest = value;
        if (this._isDevTest == true) {
            this._isTest = true;
        }
    }

    public get isLiveTest(): boolean {
        return this._isLiveTest;
    }

    public set isLiveTest(value: boolean) {
        this._isLiveTest = value;
    }

    public get isPreClient(): boolean {
        return this._isPreClient;
    }

    public set isPreClient(value: boolean) {
        this._isPreClient = value;
    }

    public get isLocaTest(): boolean {
        return this._isLocaTest;
    }

    public set isLocaTest(value: boolean) {
        this._isLocaTest = value;
    }

    public get isPrivateTestServer(): boolean {
        return this._isPrivateTestServer;
    }

    public set isPrivateTestServer(value: boolean) {
        this._isPrivateTestServer = value;
        if (this._isPrivateTestServer == true) {
            this._isTest = true;
        }
    }

    public get isLocal(): boolean {
        return this._isLocal;
    }

    public set isLocal(value: boolean) {
        this._isLocal = value;
        if (this._isLocal) {
            this.isTest = true;
        }
    }

    public get isLocalHost(): boolean {
        return this._isLocalHost;
    }

    public set isLocalHost(value: boolean) {
        this._isLocalHost = value;
        if (this._isLocalHost) {
            this.isTest = true;
        }
    }

    public set isLiveBranchingEnvironment(value: boolean) {
        this._isLiveBranchingEnvironment = value;
    }

    public get isLiveBranchingEnvironment(): boolean {
        return this._isLiveBranchingEnvironment;
    }

    public set isFeatureBranchEnvironment(value: boolean) {
        this._isFeatureBranchEnvironment = value;
    }

    public get isFeatureBranchEnvironment(): boolean {
        return this._isFeatureBranchEnvironment;
    }


    public get distributorId(): string {
        if (!this._distributorId) {
            this._distributorId = paramToString(this.urlVariables.urlParams.get(BasicConstants.DISTRIBUTOR_ID_PARAMETER), "0");
        }
        return this._distributorId;
    }

    public get accessKey(): string {
        if (!this._accessKey) {
            this._accessKey = paramToString(this.urlVariables.urlParams.get(BasicConstants.KEY_PARAMETER), "");

        }
        return this._accessKey;
    }


    public get gender(): string {
        if (!this._gender) {
            this._gender = paramToString(this.urlVariables.urlParams.get(BasicConstants.GENDER_PARAMETER), "");
        }
        return this._gender;
    }

    public get displayName(): string {
        if (!this._displayName) {
            this._displayName = paramToString(this.urlVariables.urlParams.get(BasicConstants.DISPLAY_NAME_PARAMETER), "");
        }
        return this._displayName;
    }


    public get baseURL(): string {
        if (!this._baseURL) {
            // TODO HTML5  check the logic below..  i am just moving stuff around to reduce duplication
            let url: string = window.location.href;
            // IMPORT_URL_SYNTAX will be added automaticaly, if we load the FrameOne.swf from cl/ak.
            const IMPORT_URL_SYNTAX: string = "[[IMPORT]]";
            let importUrlSyntaxIndex: number = url.indexOf(IMPORT_URL_SYNTAX);
            if (importUrlSyntaxIndex != -1) {
                this._baseURL = BasicConstants.DOMAIN_PROTOCOL + "://" + url.slice(importUrlSyntaxIndex + IMPORT_URL_SYNTAX.length, url.lastIndexOf("/"));
            }
            else {
                this._baseURL = url.slice(0, url.lastIndexOf("/"));
            }

            if (this._baseURL.indexOf("http") == 0 && this._baseURL.indexOf("https") < 0) {
                this._baseURL = BasicConstants.DOMAIN_PROTOCOL + this._baseURL.substring(4);
            }
        }
        return this._baseURL;
    }


    public get langVersionDict(): Map<any, any> {
        return this._langVersionDict;
    }

    public set langVersionDict(value: Map<any, any>) {
        this._langVersionDict = value;
    }

    public set usePayment(value: boolean) {
        this._usePayment = value;
    }

    public get usePayment(): boolean {
        return this._usePayment;
    }

    public get isLoggingActive(): boolean {
        return this._isLoggingActive;
    }

    public set isLoggingActive(value: boolean) {
        this._isLoggingActive = value;
    }

    public get showLoadingText(): boolean {
        return this._showLoadingText;
    }

    public set showLoadingText(value: boolean) {
        this._showLoadingText = value;
    }

    public get useABTest(): boolean {
        return this._useABTest;
    }

    public get cdnSubDomain(): string {
        let cdn: string;
        if (this._useFallbackCDN) {
            cdn = "media";
        } else {
            cdn = "files-" + CDN.abbreviation(this.activeCDN);
        }
        return cdn;
    }

    public get cachebreakerSubDomain(): string {
        return "cachebreaker";
    }

    public get internalServerDomain(): string {
        return BasicConstants.DOMAIN_INTERNAL_DNS;
    }

    public get gameFileSize(): string {
        return this._gameFileSize;
    }

    public set gameFileSize(value: string) {
        this._gameFileSize = value;
    }

    public get isUsabilityTest(): boolean {
        return this._isUsabilityTest;
    }

    public set isUsabilityTest(value: boolean) {
        this._isUsabilityTest = value;
    }

    public get isRegistered(): boolean {
        return this._registered;
    }

    public set isRegistered(value: boolean) {
        this._registered = value;
    }

    public get sessionStartTime(): number {
        return this._sessionStartTime;
    }

    public set sessionStartTime(value: number) {
        this._sessionStartTime = value;
    }

    public get sessionLength(): number {
        return (Date.now() - this._sessionStartTime) / 1000;
    }

    /** flag if games is using an item.xml file */
    public get useItemXML(): boolean {
        return true;
    }

    public get maintenanceMode(): boolean {
        return this._maintenanceMode;
    }

    public set maintenanceMode(value: boolean) {
        this._maintenanceMode = value;
    }

    /** flag if client is beta */
    public get isBeta(): boolean {
        return false;
    }

    public get currentCountryLanguageCode(): string {
        return this._currentCountryLanguageCode;
    }

    public set currentCountryLanguageCode(value: string) {
        this._currentCountryLanguageCode = value;
    }

    public get currentCountryLanguageVersion(): number {
        return this._currentCountryLanguageVersion;
    }

    public set currentCountryLanguageVersion(value: number) {
        this._currentCountryLanguageVersion = value;
    }

    public get useAwsTestTracking(): boolean {
        return false;
    }

    public get isCooleSpiele(): boolean {
        if (!this._isCooleSpiele) {
            this._isCooleSpiele = this.href.includes(BasicEnvironmentGlobals.REF_COOLE_SPIELE);
        }
        return this._isCooleSpiele;
    }

    /**
     * Activate user tunnel tracking for first time users or
     * if the client got valid marketing parameters from the cookie
     * @return
     */
    public get doUserTunnelTracking(): boolean {
        if (this.isFirstVisitOfGGS || this.userFromLandingPage) {
            return true;
        }
        return false;
    }

    public get isFacebook(): boolean {
        return this._networkId == GoodgamePartners.NETWORK_FACEBOOK;
    }

    public get userFromLandingPage(): boolean {
        // The campaign vars must be initialized and have to be valid
        return this.campainVars.isInitialized && this.campainVars.isValid();
    }

    private _userTunnelActive: boolean = true;

    public deactivateUserTunnelTracking(): void {
        this._userTunnelActive = false;
    }

    public get useVersionedFontSWF(): boolean {
        return this._useVersionedFontSWF;
    }

    public set useVersionedFontSWF(value: boolean) {
        this._useVersionedFontSWF = value;
    }

    public get accountCookie(): AccountCookie {
        if (!this._accountCookie) {
            this._accountCookie = new AccountCookie(EnvGlobalsHandler.globals.jsVariables.journeyHash);
        }

        return this._accountCookie;
    }


    public set sessionId(value: string) {
        if (!this._sessionId) {
            this._sessionId = value;
        }
    }

    public get sessionId(): string {
        if (!this._sessionId) {
            // Create random uint for SQL datatype unsigned INT. Using uint max value.
            this._sessionId = (Math.random() * Number.MAX_VALUE).toFixed();
        }
        return this._sessionId;
    }


    public get cacheBreakerInfo(): CachebreakerInfoObject {
        if (this._cacheBreakerInfo == null) {
            this._cacheBreakerInfo = new CachebreakerInfoObject();
        }
        return this._cacheBreakerInfo;
    }

    /**
     * Indicates if the old method of font handling is used. If so e.g. view components like
     * BasicPanel and BasicDialog will listen to BasicLanguageFontManager when font SWFs beeing loaded and will update
     * in an recursive search all found TextFields.
     *
     * Future games are planned to use the GoodgameTextField class as a wrapper for every TextField.
     * Default configuration yet is the legacy system.
     */
    public get useLegacyFontManagement(): boolean {
        return true;
    }

    // transitional flag, remove when all games use 'true'
    public get useShortPaymentHashValidity(): boolean {
        return false;
    }

    /**
     * Returns the CDN from which the game should be loaded. Can be set by 'customCDN', is default cdn otherwise.
     */
    public get activeCDN(): CDN {
        if (this._customCDN != CDN.None) {
            return this._customCDN;
        } else {
            return this._defaultCDN;
        }
    }

    /**
     * Set this to a value of 'CDN' to change the cdn that is used to load the game data from. Setting this to 'CDN.None' will cause the default cdn to be used.
     * @param value
     */
    public set customCDN(value: CDN) {
        this._customCDN = value;
        this.updateBaseURLWithCDN();
    }

    private updateBaseURLWithCDN(): void {
        const urlSubdomain: string = "files-";
        const urlStart: string = BasicEnvironmentGlobals.URL_PROTOCOL + urlSubdomain;
        if (!this.isTest && !this.isLocal && this.baseURL.indexOf(urlStart) === 0) {
            const overriddentBaseURL = BasicEnvironmentGlobals.URL_PROTOCOL + this.cdnSubDomain + this.baseURL.slice(BasicEnvironmentGlobals.URL_PROTOCOL.length + this.cdnSubDomain.length);
            logger.warn(`NOT IMPLEMENTED YET Implement CDN beaviour when we have deployment to S3: why should baseUrl be overridden from  ${this.baseURL}  to ${overriddentBaseURL} ??? `);
            // this._baseURL = overriddentBaseURL;

        }
    }

    /**
     *  set _useFallbackCDN true
     *  loads policyFile from new domain
     */
    public set fallBackCDN(value: boolean) {
        this._useFallbackCDN = value;
    }

    public get frameOneSizeInKB(): number {
        return this._frameOneSizeInKB;
    }

    public set frameOneSizeInKB(value: number) {
        this._frameOneSizeInKB = value;
    }

    /**
     *  get the information of the xml-data
     */
    public setVersionInformation(version: IVersionInformation): void {
        //_versionInfo = version;
    }

    public get versionInformation(): IVersionInformation {
        return VersionInformation.versionInstance;
    }

    /**
     * get flag describing, if smartfox will artificially slowed down to emulate slow connections
     */
    public get useLaggyClientEmulation(): boolean {
        return !!(this._urlVariables.emulateLaggyClient);
    }


    /**
     * returns the minimum delay time for emulation of laggy client
     */
    public get laggyClientMinDelay(): number {
        return this._urlVariables.laggyClientMinDelay;
    }

    /**
     * returns the maximum delay time for emulation of laggy client
     */
    public get laggyClientMaxDelay(): number {
        return this._urlVariables.laggyClientMaxDelay;
    }

    public get isIdentityManagementActive(): boolean {
        return this._isIdentityManagementActive;
    }

    public set isIdentityManagementActive(value: boolean) {
        this._isIdentityManagementActive = value;
    }

    // siren24
    public get identityManagementId(): string {
        return this._identiyManagementID;
    }

    // siren24
    public set identityManagementId(value: string) {
        this._identiyManagementID = value;
    }

    /**
     * Provide a license VO if the game uses koren identity management
     */
    public get identityManagmentLicenseVO(): IdentitiyManagementLicenseTableRegistrationVO {
        throw new Error("BasicEnvironmentGlobals, get identityManagmentLicenseVO: No VO provided!");
    }

    public get underAgeConnectionLost(): boolean {
        return this._underAgeConnectionLost;
    }

    public set underAgeConnectionLost(value: boolean) {
        this._underAgeConnectionLost = value;
    }

    public get sendUserActivityStatusToTheServer(): boolean {
        return false;
    }

    public get useLegacySocialRegistration(): boolean {
        return true;
    }

    public get isSSO(): boolean {
        return this.pln !== "" && this.sig !== "";
    }

    public get trackingVerifierIsActive(): boolean {
        return true;
    }

    public get useAnimatedGGSPreloader(): boolean {
        return false;
    }

    public get gameSwfLoadingTime(): number {
        return this._gameSwfLoadingTime;
    }

    public set gameSwfLoadingTime(value: number) {
        this._gameSwfLoadingTime = value;
    }

    public get ageGateFeatureIsActive(): boolean {
        return false;
    }

    public get previousFirstInstanceGamestate(): string {
        return this._previousFirstInstanceGamestate;
    }

    public set previousFirstInstanceGamestate(value: string) {
        this._previousFirstInstanceGamestate = value;
    }

    /**
     * Checks whether the client is in GGS environment.
     */
    public get isGGSEnvironment(): boolean {
        return this.href.indexOf(BasicConstants.GGS_DOMAIN) !== -1;
    }

    public get baseAssetsURL(): string {
        return this._baseAssetsURL;
    }

    public set baseAssetsURL(value: string) {
        this._baseAssetsURL = value;
    }
}
